
<template>
  <div>
    <div v-if="nextPayoutStr">
      <info-block small class="help-text-small">
        {{nextPayoutStr}}
      </info-block>
    </div>
    <v-list>
      <v-list-item-group>
        <template v-for="(account, idx) in accounts">
          <v-list-item :key="idx" @click="onClick(account)">
            <template>
              <v-list-item-content>
                <v-list-item-title class="d-flex flex-row justify-space-around">
                  <div
                    class="flex-grow-1 align-self-center"
                    style="word-break: break-all; white-space: normal"
                  >
                    <account-widget :account="account" />
                  </div>
                  <div class="justify-end align-self-center">
                    <v-btn
                      v-if="false"
                      :disabled="isLoading"
                      icon
                      @click="deleteAccount($event, account)"
                      class="secondary warning ml-2"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <add-account-dialog
      v-if="showAddDialog"
      :visible="showAddDialog"
      :closeAction="closeAddDialog"
    />
    <v-btn v-if="editable" :disabled="isLoading" class="primary" @click="createAccount">
      <v-icon left>mdi-bank</v-icon>{{ $t("common.add") }}
    </v-btn>
  </div>
</template>

<script>
import {EVENT_BANK_ACCOUNTS_CHANGED} from "@/plugins/eventbus"
import AccountWidget from "./AccountWidget";
import AddAccountDialog from "./AddAccountDialog";
import InfoBlock from '@/widgets/InfoBlock.vue';

export default {
  name: "AccountsWidget",
  components: {
    AccountWidget,
    AddAccountDialog,
    InfoBlock,
  },
  props: {
    value: Array,
    editable: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false
    },
    onAccountClicked: {
      type: Function
    },
  },
  data: function () {
    return {
      loadingCounter: 0,
      accounts: undefined,
      nextPayoutPossibleAt: undefined,
      showAddDialog: false,
    };
  },
  computed: {
    isLoading() {
      return this.loading || this.loadingCounter > 0
    },
    nextPayoutStr() {
      if (this.nextPayoutPossibleAt == null) {
        return ''
      }
      let dateStr = this.$datefns.formatRelativeWithTime(this.nextPayoutPossibleAt)
      return this.$t('accountsWidget.next-possible-payout', {nextDate: dateStr})
    }
  },
  mounted: function () {
    this.$eventBus.$on(EVENT_BANK_ACCOUNTS_CHANGED, this.loadAccounts);
    if (this.value) {
      this.accounts = this.value
      console.log('value', this.value)
    } else {
      this.loadAccounts()
    }
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_BANK_ACCOUNTS_CHANGED, this.loadAccounts);
  },
  watch: {
    accounts: function (val, oldVal) {
      if (oldVal !== undefined) {
        // console.log('emitting new val', val)
        this.$emit("input", val);
      }
    },
  },
  methods: {
    loadAccounts() {
      this.loadingCounter++
      this.$api.getBankAccounts()
      .then(response => {
        this.loadingCounter--
        let list = response.data.list
        this.accounts = list;
        this.nextPayoutPossibleAt = response.data.nextPayoutPossibleAt
      })
      .catch(error => {
        this.loadingCounter--
        this.$common.onError(error)
      })
    },
    deleteAccount($event, account) {
      $event.stopPropagation();
      console.log('TBD', account);
    },
    createAccount() {
      this.showAddDialog = true;
    },
    onClick(account) {
      this.onAccountClicked && this.onAccountClicked(account)
    },
    closeAddDialog() {
      this.showAddDialog = false;
    },
  },
};
</script>